// extracted by mini-css-extract-plugin
export var button = "read-more-module--button--cd62a";
export var buttonLess = "read-more-module--button-less--17414";